import TeamInfoField from "./team-info-field";
import TeamActionField from './team-action-field';
import TeamType from './team-type-field';


const TeamFields = {
    Info: TeamInfoField,
    Action: TeamActionField,
    Type: TeamType,
};

export default TeamFields;